(() => {
  if (customElements.get('ooo-collection-card')) return;
  class CollectionCard extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-variant-swatch]');
        if (!swatch || !this.contains(swatch) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.selectVariant(swatch);
      });
      this.addEventListener('keydown', (event) => {
        const swatch = event.target.closest('[data-variant-swatch]');
        if (swatch && event.key === ' ') {
          event.preventDefault();
          this.selectVariant(swatch);
        }
      });
    }
    selectVariant(swatch) {
      this.querySelectorAll('[data-variant-swatch]').forEach((choice) => {
        choice.setAttribute('aria-pressed', String(choice === swatch));
      });
      this.querySelectorAll('[data-product-link]').forEach((link) => {
        link.href = swatch.href;
      });
      const image = this.querySelector('.ooo-collection-card__image');
      if (image && swatch.dataset.variantImage) {
        image.srcset = swatch.dataset.variantSrcset || '';
        image.src = swatch.dataset.variantImage;
        image.alt = `${this.querySelector('.ooo-collection-card__title').textContent.trim()} — ${swatch.dataset.variantLabel}`;
      }
      const hoverImage = this.querySelector('[data-variant-hover-image]');
      const hoverUrl = swatch.dataset.variantHover;
      hoverImage.hidden = !hoverUrl;
      if (hoverUrl) {
        hoverImage.src = hoverUrl;
        hoverImage.alt = `${this.querySelector('.ooo-collection-card__title').textContent.trim()} — ${swatch.dataset.variantLabel}, in use`;
      } else {
        hoverImage.removeAttribute('src');
      }
      this.querySelector('.ooo-collection-card__media').dataset.hasHover = String(Boolean(hoverUrl));
      this.querySelector('[data-variant-price]').textContent = swatch.dataset.variantPrice;
      this.querySelector('[data-selected-variant-label]').textContent = swatch.dataset.variantLabel;
    }
  }
  customElements.define('ooo-collection-card', CollectionCard);
})();
